import _ from 'lodash';

const ASYNC_FUNCTIONS = new Set();
const setAsyncFunctions = (funcs) => {
    if (_.isArray(funcs)) {
        return _.forEach(funcs, (func) => ASYNC_FUNCTIONS.add(func));
    }
    return ASYNC_FUNCTIONS.add(funcs);
};

const isAsyncFunction = (func) => ASYNC_FUNCTIONS.has(func);
export {
    setAsyncFunctions,
    isAsyncFunction
};